<template>
  <el-row v-loading="loading" element-loading-text="加载中..." class="user">
    <div class="user-content">
      <div class="user-left">
        <h2 class="Medium">{{ GuestCName }}</h2>
        <p @click="loginOut">注销</p>
        <ul>
          <router-link
            v-for="item in menu"
            :to="{ path: item.path }"
            tag="li"
            active-class="active"
            :key="item.path"
          >
            <span>{{ item.name }}</span>
            <i></i>
          </router-link>
        </ul>
        <div class="user-btn">
          <span @click="goReservation">去订房</span>
        </div>
      </div>
      <div class="user-right">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
  </el-row>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import { logOut, getmemberInfo } from "@/request/member.js";
export default {
  name: "user",
  data() {
    return {
      menu: [
        {
          name: "我的资料",
          path: "userMessage",
          active: true,
        },
        {
          name: "预订记录",
          path: "record",
          active: false,
        },
        {
          name: "修改密码",
          path: "changePassword",
          active: false,
        },
      ],
      loading: false,
    };
  },
  computed: {
    ...mapState("member", ["GuestCName"]),
    ...mapGetters("member", ["Token", "ProfileId"]),
  },
  methods: {
    ...mapMutations("member", ["updateUserInfo"]),
    goReservation() {
      this.$router.push({
        path: "/index",
      });
    },
    //获取会员信息
    getmemberInfo() {
      this.loading = true;
      getmemberInfo(this.Token, { profileId: this.ProfileId })
        .then((res) => {
          if (res.response.Code == 200) {
            const data = res.response;
            this.updateUserInfo(data);
            this.loading = false;
          } else {
            this.$message.error(res.response.msg);
            this.$router.push({
              path: "/login",
            });
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //注销
    loginOut() {
      logOut(this.Token)
        .then((res) => {
          this.$store.dispatch("member/logout");
          this.$router.push({
            path: "/login",
          });
        })
        .catch((err) => {});
    },
  },
  mounted() {
    this.getmemberInfo();
  },
};
</script>
<style scoped>
.user {
  width: 1200px;
  background: #fff;
  margin: auto;
  margin-top: 24px;
}
.user-content {
  display: flex;
  height: 100%;
}
.user-left {
  width: 228px;
  height: 100%;
  border-right: 1px solid #e9e9e9;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding-top: 38px;
}
.user-left h2 {
  font-size: 24px;
  color: #000;
  margin-bottom: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 12px;
  line-height: 32px;
}
.user-left > p {
  font-size: 14px;
  color: #499bfc;
  margin-bottom: 26px;
  cursor: pointer;
}
.user-left ul {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.user-left ul li {
  display: flex;
  font-size: 16px;
  color: #333;
  height: 40px;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  cursor: pointer;
  position: relative;
}
.user-left ul li i {
  width: 3px;
  height: 40px;
  background: #0f90ff;
  position: absolute;
  top: 0;
  right: 0;
  display: none;
}
.user-left ul li.active {
  background: #e7f7ff;
}
.user-left ul li.active i {
  display: block;
}
.user-btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
.user-btn span {
  display: flex;
  width: 88px;
  height: 40px;
  border: 1px solid #2a82e4;
  border-radius: 20px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #2a82e4;
  box-sizing: border-box;
  cursor: pointer;
}
.user-right {
  flex: 1;
}
</style>
